type CatalogPaginationProps = {
  language: 'mn' | 'en';
  currentPage: number;
  paginationItems: Array<number | 'ellipsis-start' | 'ellipsis-end'>;
  hasPrevPage: boolean;
  hasNextPage: boolean;
  onPageChange: (page: number) => void;
};

export function CatalogPagination({
  language,
  currentPage,
  paginationItems,
  hasPrevPage,
  hasNextPage,
  onPageChange,
}: CatalogPaginationProps) {
  return (
    <div className="flex flex-wrap items-center justify-center gap-3">
      <button
        type="button"
        onClick={() => onPageChange(currentPage - 1)}
        disabled={!hasPrevPage}
        className="rounded-full border border-[var(--ubuy-border-soft)] bg-white px-4 py-2 text-sm font-bold text-[var(--ubuy-title)] transition hover:border-[var(--ubuy-accent)] disabled:cursor-not-allowed disabled:opacity-40"
      >
        {language === 'mn' ? 'Өмнөх' : 'Previous'}
      </button>
      <div className="flex items-center gap-2">
        {paginationItems.map((item) => {
          if (typeof item !== 'number') {
            return (
              <span
                key={item}
                className="flex h-11 min-w-8 items-center justify-center text-sm font-semibold text-[var(--ubuy-muted)]"
              >
                ...
              </span>
            );
          }

          const isActive = item === currentPage;
          return (
            <button
              key={item}
              type="button"
              onClick={() => onPageChange(item)}
              aria-current={isActive ? 'page' : undefined}
              className={`h-11 min-w-11 rounded-full border px-4 text-sm font-semibold transition-all ${
                isActive
                  ? 'border-[var(--ubuy-accent)] bg-[var(--ubuy-accent)] text-[var(--ubuy-title)]'
                  : 'border-[var(--ubuy-border-soft)] bg-white text-[var(--ubuy-title)] hover:border-[var(--ubuy-accent)]'
              }`}
            >
              {item}
            </button>
          );
        })}
      </div>
      <button
        type="button"
        onClick={() => onPageChange(currentPage + 1)}
        disabled={!hasNextPage}
        className="rounded-full border border-[var(--ubuy-border-soft)] bg-white px-4 py-2 text-sm font-bold text-[var(--ubuy-title)] transition hover:border-[var(--ubuy-accent)] disabled:cursor-not-allowed disabled:opacity-40"
      >
        {language === 'mn' ? 'Дараах' : 'Next'}
      </button>
    </div>
  );
}
